/**
 * Oracle Object Detail Feature Module
 *
 * Registers the oracle-object-detail workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the oracle-object-detail workspace component
registerWorkspaceComponent(
  'oracle-object-detail',
  lazyWorkspaceTab(() => import('./components/OracleObjectDetailTab').then((m) => ({ default: m.OracleObjectDetailTab }))),
);

// Re-export components
